<template>
    <v-dialog persistent v-model="dialog" max-width="50%" content-class="lead-form-details-dialog">
        <div class="detail-container">
            <div class="header flex space-between mb-3">
                <h2 class="--green">{{data.name}}</h2>
                <button class="pointer close-button" @click="$emit('close')">
                    <v-icon color="#1F8F58">mdi-close</v-icon>
                </button>
            </div>

            <div class="content">
                <div class="card" v-for="input in data.form_inputs" :key="input.id">
                    <h4 class="--font mb-2"> 
                        {{ input.label }}
                        <span v-if="input.is_compulsory">*</span> 
                    </h4> 
                    <input
                        v-if="input.input_type === 'string' || input.input_type === 'integer'" 
                        type="text" 
                        disabled 
                        readonly 
                        class="input-box" 
                        :placeholder="input.hint">
                    
                    <div v-if="input.input_type === 'radio_box_group'">
                        <input
                            v-for="option in input.option_list"
                            :key="option.id"
                            type="text" 
                            disabled 
                            readonly 
                            class="radio-box" 
                            :placeholder="option.display_text"
                            style="margin : 5px 0;">
                    </div>
                    <div v-if="input.input_type==='drop_down'">
                         <v-select style="min-height:100px !important"
                            disable-lookup
                            readonly
                            dense
                            outlined 
                            disabled
                            background-color="#F3F3F3"
                            :placeholder="input.label"/>               
                    </div>

                    <div v-if="input.input_type === 'checkbox_group'">
                        <div class="flex checkbox" v-for="option in input.option_list" :key="option.id">
                            <input type="checkbox">
                            <span></span>
                            <label class="single-select"> {{ option.display_text }} </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </v-dialog>
</template>

<script>
export default {
    name : 'leadFormDetails',

    props : {
        dialog : {
            type : Boolean,
            required : true
        },

        data : {
            type : Object 
        }
    }
}
</script>

<style lang="scss" scoped>

.detail-container {
    padding: 15px 20px;
    
}

.close-button {
    background-color: red;
    padding: 5px;
    background: #EFF6F3;
    border-radius: 7px;
}

.card {
    border: 1px solid #DDE6DE;
    box-sizing: border-box;
    border-radius: 7px;
    margin: 8px 0;
    padding : 10px;
}

input {
    background: #F3F3F3;
    border: 0.5px solid #797878;
    box-sizing: border-box;
    border-radius: 3px;
    width: 100%;
    height: 40px;
    padding-left: 10px;
   

}


.radio-box {
    text-align: center;
    padding: 0;

    &::placeholder {
        color: black;
        font-weight: 500;
    }
}

.checkbox {
    background: #F3F3F3;
    border: 0.5px solid #797878;
    box-sizing: border-box;
    border-radius: 3px;
    height: 60px;
    position: relative;
    margin: 10px 0;
    overflow: auto;

   
}

.checkbox label {
    color: #7a7878;
    font-weight: 500;
    margin-left: 40px;
   

  
}

.checkbox input {
    accent-color: red;
    width: 20px;
    height: 20px;
    visibility: hidden;
}

.checkbox span {
    position: absolute;
    top: 8px;
    left: 25px;
    height: 22px;
    width: 22px;
    background-color: transparent;
    border: 2px solid #818181;
    border-radius: 2px;
}

</style>

<style lang="scss">
.lead-form-details-dialog.v-dialog {
	width: 25%;
	background-color: white;
    min-height: 300px;
}
</style>